/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  const SHIPPING_PRICE = 499;
  const FREE_SHIPPING_THRESHOLD_PRICE = 6000;

  var windowWidth = window.innerWidth;

  function formatMoney(price, trimZeroCents = true) {
    if (price === null || price === undefined || price === "") return "";
    let result = window.Shopify.formatMoney(price, window.theme.moneyFormat);
    if (trimZeroCents) {
      result = result.replace('.00', '');
    }
    return result;
  }

  window.addEventListener("resize", function() {
    if (windowWidth === window.innerWidth) return;
    windowWidth = window.innerWidth;
    window.dispatchEvent(new CustomEvent('widthResize'));
  });

  function initAnnouncementBar() {
    var announcementBar = document.querySelector('.AnnouncementBar');
    if (!announcementBar) return;

    var wrapper = announcementBar.querySelector('.AnnouncementBar__Wrapper');
    var content = announcementBar.querySelector('.AnnouncementBar__Content');
    var text = announcementBar.querySelector('.AnnouncementBar__Text');
    var duplicatedText = false;
    var animationInterval;

    function startAnimation() {
      if (!duplicatedText) {
        duplicatedText = true;
        content.appendChild(text.cloneNode(true))
      }
      announcementBar.classList.add('AnnouncementBar--animating');
    }

    function stopAnimation() {
      announcementBar.classList.remove('AnnouncementBar--animating');
    }

    function recalculate() {
      if (wrapper.offsetWidth > text.offsetWidth) {
        stopAnimation();
        return;
      }
      startAnimation();
    }

    window.addEventListener('widthResize', recalculate);
    recalculate();
  }

  function initProductStickyBottom() {
    var stickyBottom = document.querySelector('.ProductForm__StickyBottom');
    var trigger = document.querySelector('.ProductForm__Quantity-AddToCart');

    if (!stickyBottom || !trigger) return;

    var observer = new IntersectionObserver(function(entries) {
      if (!entries[0]) return;

      if (entries[0].isIntersecting) {
        stickyBottom.classList.remove('shown');
      } else {
        if (entries[0].boundingClientRect.top <= 20) {
          stickyBottom.classList.add('shown');
        }
      }
    }, {
      rootMargin: "-20px 0px",
      threshold: 1,
    });

    observer.observe(trigger);
  }

  function initProductSubscriptions() {
    var sealsubsContainer = document.querySelector('.sealsubs-target-element');
    var productSection = document.querySelector('.Product');
    var productForm = productSection?.querySelector('form.ProductForm');
    var productSize = productForm && productForm.querySelector('.ProductSize');

    if (!sealsubsContainer || !productForm || !productSize) return;

    var subscriptionDataMap = new Map();
    var showSaleBadge = !!productSection?.hasAttribute('data-sale-badge');
    const hasFreeProduct = productForm.dataset.hasFreeProduct == 'true';
    // const freeProductPrice = hasFreeProduct ? parseFloat(productForm.querySelector('[data-free-product-markup]').dataset.freeProductPrice) : 0;
    const freeProductPrice = 0;

    const productJSON = JSON.parse(productSection.querySelector('[data-product-json]').innerHTML);
    const {variantsMetafields} = productJSON;

    try {
      const productData = JSON.parse(sealsubsContainer.getAttribute('data-product'));
      const sizeOptionsIndex = productData.options.findIndex(function(value) {
        return (value || '').toLowerCase() === 'size';
      });

      if (sizeOptionsIndex > -1) {
        const singlePrice = Math.min(...productData.variants.map((variant) => variant.price));
        const singlePriceWithShipping = singlePrice + SHIPPING_PRICE;
        // const minSubscriptionPrice = Math.min(...productData.variants.map((variant) => variant.selling_plan_allocations[0].price));
        productData.variants.forEach(function(variant) {
          const price = variant.price;
          const priceWithShipping = price + (price > FREE_SHIPPING_THRESHOLD_PRICE ? 0 : SHIPPING_PRICE) + freeProductPrice;
          const compareAtPrice = variant.compare_at_price;
          const compareAtPriceWithShipping = compareAtPrice ? (compareAtPrice + (price > FREE_SHIPPING_THRESHOLD_PRICE ? 0 : SHIPPING_PRICE) + freeProductPrice) : compareAtPrice;
          const subscriptionPrice = variant.selling_plan_allocations[0].price;
          const quantity = parseInt(variant.options[sizeOptionsIndex]) || 1;
          const pricePerItem = variant.price / quantity;
          const subscriptionPricePerItem = subscriptionPrice / quantity;
          const variantMetafields = variantsMetafields[variant.id];
          const {servings} = variantMetafields;
          subscriptionDataMap.set(variant.options[sizeOptionsIndex], {
            price: price,
            priceWithShipping: priceWithShipping,
            compareAtPrice: compareAtPrice,
            compareAtPriceWithShipping: compareAtPriceWithShipping,
            subscriptionPrice: subscriptionPrice,
            quantity: quantity,
            pricePerItem: pricePerItem,
            subscriptionPricePerItem: subscriptionPricePerItem,
            // discountPercent: singlePrice !== price ? Math.round((singlePrice * quantity - price) / ( singlePrice * quantity ) * 100) : null,
            // subscriptionDiscountPercent: minSubscriptionPrice !== subscriptionPrice ? Math.round((minSubscriptionPrice * quantity - subscriptionPrice) / ( minSubscriptionPrice * quantity ) * 100) : null,
            generalDiscount: priceWithShipping - subscriptionPrice,
            servings,
          });
        });
      }
    } catch (error) {};

    let activeOptionData = null;
    function updateSubscriptionUI() {
      
      const isSubscription = !!document.querySelector('input[name="selling_plan"]')?.value;
      activeOptionData = null;
      
      document.querySelectorAll('.ProductSize__Item').forEach(function (productSizeItem) {
        const data = subscriptionDataMap.get(productSizeItem.getAttribute('data-value'));
        
        const singleItemPrice = productSizeItem.querySelector('.ProductSize__ItemSinglePrice');
        
        if (productSizeItem.querySelector('input[type="radio"]')?.checked) {
          activeOptionData = data;
          
        }

        if (!data) return;

        const {servings, subscriptionPricePerItem, pricePerItem} = data;
        if (servings > 0) {
          const totalPrice = isSubscription ? subscriptionPricePerItem : pricePerItem;
          const pricePerServing = totalPrice / servings;
          singleItemPrice.innerText = `${formatMoney(pricePerServing)} PER SERVING`;
        } else {
          singleItemPrice.innerText = `(${formatMoney(isSubscription ? subscriptionPricePerItem : pricePerItem)} EACH)`;
        }
        

        // console.log(data);

        // if (isSubscription) {
        //   if (info) {
        //     info.textContent = '(every ' + quantity + ' month' + (quantity > 1 ? 's' : '') + ')'
        //   }
        // }

        // if (price) {
        //   const data = subscriptionDataMap.get(dataValue);
        //   price.innerText = formatMoney((isSubscription ? data.subscriptionPrice : data.price) / (isKit ? quantity * 3 : quantity));
        // }
        // console.log(productSizeItem)
      });

      // document.querySelectorAll('.sls-option-container:not(.sls-disabled-option-container)').forEach(function (slsOptionContainer) {
      //   var planGroup = slsOptionContainer.getAttribute('data-selling-plan-group');
      //   var isSubscriptionOption = slsOptionContainer.hasAttribute('data-selling-plan-group');
      // });

      const sellingPlanGroup = document.querySelector('.sls-option-container:not(.sls-disabled-option-container)[data-selling-plan-group]');
      const onTimePlanGroup = document.querySelector('.sls-option-container:not(.sls-disabled-option-container):not([data-selling-plan-group])');
      if (sellingPlanGroup) {
        
        const comparePriceContainer = sellingPlanGroup.querySelector('.sls-price-container .sls-price-below');
        
        if (comparePriceContainer) {
          comparePriceContainer.innerText = activeOptionData?.compareAtPriceWithShipping ? formatMoney(activeOptionData?.compareAtPriceWithShipping, false) : formatMoney(activeOptionData?.priceWithShipping, false);
        }
        if (activeOptionData?.generalDiscount) { 

          const sellingPlanGroupName = sellingPlanGroup.querySelector('.sls-selling-plan-group-name');
          
          if (sellingPlanGroupName) {
            
            let sellingPlanGroupNameDiscount = sellingPlanGroupName.querySelector('.sls-selling-plan-group-name-discount');
            const popupDiscountInfo = document.querySelector('.sls-selling-plan-group-name-discount.m-popup');
            popupDiscountInfo.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              showDiscountInfo(activeOptionData.price, activeOptionData.subscriptionPrice, activeOptionData.quantity, activeOptionData.generalDiscount, freeProductPrice);
            });
            if (!sellingPlanGroupNameDiscount) {
              sellingPlanGroupNameDiscount = document.createElement('span');
              sellingPlanGroupNameDiscount.classList.add('sls-selling-plan-group-name-discount');
              sellingPlanGroupName.appendChild(sellingPlanGroupNameDiscount);
              sellingPlanGroupNameDiscount.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                showDiscountInfo(activeOptionData.price, activeOptionData.subscriptionPrice, activeOptionData.quantity, activeOptionData.generalDiscount, freeProductPrice);
              });
            }
            sellingPlanGroupNameDiscount.innerText = `Save ${formatMoney(Math.round(activeOptionData.generalDiscount / 100) * 100)}`;
          }
        }

        // if (hasFreeProduct) { /* hide Free travel tin badge on product page  */
        //   let freeProductMarkupForSellingPlanGroup = sellingPlanGroup.querySelector('.SellingPlanGroup__FreeProduct');
        //   if (!freeProductMarkupForSellingPlanGroup) {
        //     const freeProductMarkup = productForm.querySelector('[data-free-product-markup]').innerHTML;
        //     freeProductMarkupForSellingPlanGroup = document.createElement('div');
        //     freeProductMarkupForSellingPlanGroup.classList.add('SellingPlanGroup__FreeProduct');
        //     freeProductMarkupForSellingPlanGroup.innerHTML = freeProductMarkup;
        //     sellingPlanGroup.append(freeProductMarkupForSellingPlanGroup);
        //   }
        // }
      }
      if (onTimePlanGroup) {
        const comparePriceContainer = onTimePlanGroup.querySelector('.sls-price-container .sls-price-below');
        if (comparePriceContainer) {
          comparePriceContainer.innerText = formatMoney(activeOptionData?.compareAtPrice, false);
        }

        // if (hasFreeProduct) {
        //   let onTimePlanGroupDescription = onTimePlanGroup.querySelector('.OneTimePurchase__CustomDescription');
        //   if (!onTimePlanGroupDescription) {
        //     onTimePlanGroupDescription = document.createElement('div');
        //     onTimePlanGroupDescription.classList.add('OneTimePurchase__CustomDescription', 'sls-selling-plan-description-content');
        //     onTimePlanGroupDescription.innerHTML = `
        //       <ul>
        //         <li>
        //           ${theme.strings.noFreeProduct}
        //         </li>
        //       </ul>
        //     `;

        //     const onTimePlanGroupLabelContainer = onTimePlanGroup.querySelector('.sls-label-container');
        //     onTimePlanGroupLabelContainer.append(onTimePlanGroupDescription);
        //   } else {
        //     onTimePlanGroupDescription.innerHTML = `
        //       <ul>
        //         <li>
        //           ${theme.strings.noFreeProduct}
        //         </li>
        //       </ul>
        //     `;
        //   }
        // }
        
      }
      if (showSaleBadge) {
        if (sellingPlanGroup) {
          let saleBadge = sellingPlanGroup.querySelector('.sls-price-container .sale-badge');
          if (!saleBadge) {
            saleBadge = document.createElement('div');
            saleBadge.classList.add('sale-badge');
            saleBadge.innerText = 'Flash Sale';
            sellingPlanGroup.querySelector('.sls-price-container')?.append(saleBadge);
          }
        }
        if (onTimePlanGroup) {
          let saleBadge = onTimePlanGroup.querySelector('.sls-price-container .sale-badge');
          if (!saleBadge) {
            saleBadge = document.createElement('div');
            saleBadge.classList.add('sale-badge');
            saleBadge.innerText = 'Flash Sale';
            onTimePlanGroup.querySelector('.sls-price-container')?.append(saleBadge);
          }
        }
      }
    }

    document.addEventListener('sealsubs:subscription_widget_created', function(event) {
      updateSubscriptionUI();
      window.productSubscriptionEnabled = true;
    });

    if (sealsubsContainer.querySelector('.sls-purchase-options-container')) {
      updateSubscriptionUI();
      window.productSubscriptionEnabled = true;
    }

    document.addEventListener('sealsubs:price_update', function(event) {
      var priceValue = event.detail.price;
      var compareAtPriceValue = event.detail.compareAtPrice;

      var output = '';

      if (priceValue === compareAtPriceValue) {
        output = '<span class="ProductMeta__Price Price">' + formatMoney(priceValue) + '</span>';
      } else {
        output = '<s class="ProductMeta__Price Price" aria-hidden="true">' + formatMoney(compareAtPriceValue) + '</s> &nbsp;<span class="ProductMeta__Price Price">' + formatMoney(priceValue) + '</span>';
      }

      document.querySelectorAll('.ProductMeta__PriceList').forEach(function(element) {
        var currencyElement = element.querySelector('.ProductMeta__Currency');
        element.innerHTML = output;
        if (currencyElement) {
          element.appendChild(currencyElement);
        }
      });
    });

    document.addEventListener('sealsubs:price_update', function(event) {
      const isSubscription = event.detail.isSubscriptionPrice;

      document.querySelectorAll('.ProductForm__StickyBottom-Text').forEach(function(text) {
        text.textContent = isSubscription ? 'Subscription' : '';
      });

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          updateSubscriptionUI();
        });
      });
    });
  }

  function initProductInfo() {
    const productInfo = document.querySelectorAll('.product-info');
    productInfo.forEach(function (container) {
      const slider = container.querySelector('.product-info__slider');
      const items = container.querySelectorAll('.item');
      if (!slider || items.length < 4) return;
      var flky = new Flickity( slider, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: true,
        groupCells: 3,
        percentPosition: false,
        prevNextButtons: true,
        pageDots: false,
        setGallerySize: true,
        // sets the height of gallery
        // disable if gallery already has height set with CSS
        watchCSS: true
      });
    });
  }

  function initCartCount() {
    var cartCountElement = document.querySelector('.Header__CartDot');
    if (!cartCountElement) return;

    function updateVisibility() {
      if (!cartCountElement.textContent || cartCountElement.textContent === '0') {
        cartCountElement.classList.remove('is-visible');
      } else {
        cartCountElement.classList.add('is-visible');
      }
    }

    var observer = new MutationObserver(updateVisibility);
    observer.observe(cartCountElement, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: true,
      characterDataOldValue: false
    });

    updateVisibility();
  }

  function initProductGallery() {
    const emblaNodes = document.querySelectorAll('.embla')
    if (!window.EmblaCarousel || !emblaNodes?.length) return;

    emblaNodes.forEach(function(emblaNode) {
      const viewportNode = emblaNode.querySelector('.embla__viewport');
      const dotsContainer = emblaNode.querySelector('.embla__dots');
      const slides = [...emblaNode.querySelectorAll('.embla__slide')];
      const slidesForMobile = slides.filter((slide) => !slide.hasAttribute('data-only-desktop'));
      const slidesForDesktop = slides.filter((slide) => !slide.hasAttribute('data-only-mobile'));
      const thumbs = emblaNode.closest('.Product__Gallery')?.querySelectorAll('.Product__SlideshowNavImage');
      let dotNodes = [];
      let isMobile = window.innerWidth < 768;

      const emblaApi = EmblaCarousel(viewportNode, {
        slides: isMobile ? slidesForMobile : slidesForDesktop,
      });

      const addDotBtnsWithClickHandlers = () => {
        dotsContainer.innerHTML = emblaApi
          .scrollSnapList()
          .map(() => '<button class="embla__dot" type="button"></button>')
          .join('')

        const scrollTo = (index) => {
          emblaApi.scrollTo(index)
        }

        dotNodes = Array.from(dotsContainer.querySelectorAll('.embla__dot'))
        dotNodes.forEach((dotNode, index) => {
          dotNode.addEventListener('click', () => scrollTo(index), false)
        });
      }

      emblaApi
        .on('init', addDotBtnsWithClickHandlers)
        .on('reInit', addDotBtnsWithClickHandlers)

      function updateNav() {
        const selected = emblaApi.selectedScrollSnap();
        const selectedSlideAllIndex = slides.indexOf(isMobile ? slidesForMobile[selected] : slidesForDesktop[selected]);
        thumbs.forEach((thumb) => thumb.classList.remove('active'));
        dotNodes.forEach((dot) => dot.classList.remove('active'));
        thumbs[selectedSlideAllIndex]?.classList.add('active');
        dotNodes[selected]?.classList.add('active')
      }

      emblaApi
        .on('init', updateNav)
        .on('reInit', updateNav)
        .on('select', updateNav)

      emblaApi.on('destroy', () => {
        console.log('destroy');
      });

      thumbs?.forEach(function(thumb) {
        thumb.addEventListener('click', function(event) {
          event.preventDefault();
          const index = [...thumbs].filter((thumb) => thumb.offsetParent).indexOf(thumb);
          emblaApi.scrollTo(index);
        });
      });

      window.emblaApi = emblaApi;

      window.addEventListener('resize', function() {
        if (window.innerWidth < 768 && !isMobile || window.innerWidth >= 768 && isMobile) {
          isMobile = window.innerWidth < 768
          emblaApi.reInit({
            slides: isMobile ? slidesForMobile : slidesForDesktop,
          });
        }
      });
    });
  }

  function initImagePopup() {
    document.querySelectorAll('[data-action="open-image-popup"]').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        if (!window.GLightbox || !anchor.href) return;
        event.preventDefault();
        const gallery = GLightbox({
          elements: [
            {
                'href': anchor.href,
                'type': 'image',
                'title': '',
                'description': '',
            }
          ]
        });
        gallery.open();
      })
    });
  }

  let addingToCart = false;

  async function addToCart(variantIds, quantity = 1) {
    if (addingToCart || !variantIds?.length) return;

    addingToCart = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    let response;

    try {
      response = await fetch('/cart/add.js', {
        body: JSON.stringify({ items: variantIds.map((variantId) => ({ id: variantId, selling_plan: undefined, quantity: quantity })) }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      });
    } catch (error) {
      console.error(error);
    }

    if (response?.ok) {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: null,
          quantity: variantIds.length * quantity
        }
      }));
    }

    addingToCart = false;
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  function initCrossSell() {
    document.querySelectorAll('.cross-sell').forEach((container) => {
      const items = [...container.querySelectorAll('.cross-sell__item')];
      const allVariantIds = items.map((item) => item.getAttribute('data-variant-id')).filter((id) => !!id);

      items.forEach((item) => {
        item.querySelector('.cross-sell__item-add')?.addEventListener('click', (event) => {
          event.preventDefault();
          const variantId = item.getAttribute('data-variant-id');
          if (variantId) {
            addToCart([variantId]);
          }
        });
      });

      container.querySelector('.cross-sell__add-all')?.addEventListener('click', (event) => {
        event.preventDefault();
        addToCart(allVariantIds);
      });
    });
  }

  function initInfoPopup() {
    const infoPopups = document.querySelectorAll('.info-popup');
    if (!infoPopups?.length) return;

    infoPopups.forEach((infoPopup) => {
      infoPopup.querySelectorAll('.info-popup__overlay, .info-popup__close').forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          infoPopup.classList.remove('info-popup--shown');
        });
      });
    });


    document.querySelectorAll('[data-open-info-popup]').forEach((trigger) => {
      const query = trigger.getAttribute('data-open-info-popup');
      const popup = query ? document.querySelector(query): null;
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        popup?.classList?.add('info-popup--shown');
      });
    });
  }

  function showDiscountInfo(regularPrice, subscriptionPrice, quantity, generalDiscount, freeProductPrice) {
    const discountInfo = document.querySelector('.discount-info');
    if (!discountInfo) return;

    const shippingPrice = regularPrice > FREE_SHIPPING_THRESHOLD_PRICE ? 0 : SHIPPING_PRICE;

    discountInfo.classList.add('info-popup--shown');

    discountInfo.querySelectorAll('[data-regular-price]').forEach((element) => {
      element.innerText = formatMoney(regularPrice);
    });
    discountInfo.querySelectorAll('[data-shipping-price]').forEach((element) => {
      element.innerText = shippingPrice ? formatMoney(shippingPrice) : 'FREE';
    });
    discountInfo.querySelectorAll('[data-free-product-price]').forEach((element) => {
      element.innerText = freeProductPrice ? formatMoney(freeProductPrice) : 'FREE';
    });
    discountInfo.querySelectorAll('[data-regular-price-with-shipping]').forEach((element) => {
      element.innerText = formatMoney(regularPrice + shippingPrice + freeProductPrice);
    });
    discountInfo.querySelectorAll('[data-subscription-price]').forEach((element) => {
      element.innerText = formatMoney(subscriptionPrice);
    });
    discountInfo.querySelectorAll('[data-quantity]').forEach((element) => {
      element.innerText = quantity > 1 ? `(${quantity} units)` : '';
    });
    discountInfo.querySelectorAll('[data-discount-percent]').forEach((element) => {
      element.innerText = formatMoney(generalDiscount);
    });
  }

  var initMethods = [
    initAnnouncementBar,
    initProductStickyBottom,
    initProductSubscriptions,
    initProductInfo,
    initCartCount,
    initProductGallery,
    initImagePopup,
    initCrossSell,
    initInfoPopup,
  ];

  function init() {
    for (var i = 0; i < initMethods.length; i++) {
      try {
        initMethods[i]();
      } catch(error) {
      alert('--------------> ' +  i );
        console.error(error);
      }
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

class MultiproductIngredients extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      showIngredientsButtons: this.querySelectorAll('[data-show-ingredients]'),
      ingredientsContainers: this.querySelectorAll('[data-ingredients-container]'),
    }

    this.elements.showIngredientsButtons.forEach((showIngredientsButton) => {
      showIngredientsButton.addEventListener('click', this.showIngredients.bind(this));
    });
  }

  showIngredients(event) {
    const {currentTarget} = event;
    const blockId = currentTarget.dataset.blockId;

    this.elements.showIngredientsButtons.forEach((showIngredientsButton) => {
      const buttonBlockId = showIngredientsButton.dataset.blockId;
      showIngredientsButton.setAttribute('aria-active', buttonBlockId == blockId);
    });

    this.elements.ingredientsContainers.forEach((ingredientsContainer) => {
      const ingredientsContainerBlockId = ingredientsContainer.dataset.blockId;
      ingredientsContainer.setAttribute('aria-hidden', ingredientsContainerBlockId != blockId);
    })
  }
}

customElements.define('multiproduct-ingredients', MultiproductIngredients);